import { TaskCategory, TaskInternalType, TaskStatus } from '@gcv/shared';

import type { TaskDetails, TaskDrawerField } from '../../tasks/tasks.model';
import { isGroupedTaskView } from './is-grouped-task-view';

/** Grouped tasks render the subtask table instead of these per-task fields. */
export const shouldRenderTaskDrawerField = (
  task: TaskDetails | null,
  field: TaskDrawerField,
  fieldName: string
): boolean => {
  if (!task || isGroupedTaskView(task)) {
    return false;
  }

  if (task.internalType !== TaskInternalType.DOCUMENTS && fieldName === 'requirementName') {
    return false;
  }

  if (fieldName === 'completedHow' || fieldName === 'systemNote') {
    return (
      task.internalType === TaskInternalType.SEEDLING_QUESTIONNAIRE_COMPLETE &&
      task.status === TaskStatus.COMPLETE
    );
  }

  const matchesStatus =
    field.state.includes(task.status) ||
    [TaskStatus.OPEN, TaskStatus.COMPLETE].every((s) => field.state.includes(s));
  const matchesCategory =
    field.type.includes(task.taskCategory) ||
    [TaskCategory.USER, TaskCategory.SYSTEM].every((s) => field.type.includes(s));

  return matchesStatus && matchesCategory;
};
